import {AHEventContainer} from "abusesa-js/AHEvent";

function normalizeValue(value) {
    const type = typeof value;
    if (["string", "number", "boolean"].indexOf(type) == -1) {
        throw new Error("Invalid value type " + type);
    }
    return "" + value;
}

function normalizeDict(dict) {
    const result = {};
    Object.keys(dict).forEach(key => {
        const value = dict[key];
        if (Array.isArray(value)) {
            result[key] = value.map(normalizeValue);
        } else {
            result[key] = normalizeValue(value);
        }
    });
    return result;
}

const obj2event = function() {
    const _container = new AHEventContainer();

    return function(obj) {
        return _container.create(normalizeDict(obj));
    };
};

export default obj2event;



// WEBPACK FOOTER //
// ./src/lib/obj2event.js